import { render } from "./QueueStatus.vue?vue&type=template&id=5daaa58c&scoped=true"
import script from "./QueueStatus.vue?vue&type=script&lang=js"
export * from "./QueueStatus.vue?vue&type=script&lang=js"

import "./QueueStatus.vue?vue&type=style&index=0&id=5daaa58c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5daaa58c"]])

export default __exports__